import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  connect() {
    this.openInfo = this.element.querySelector('.open-info');
    this.closeInfo = this.element.querySelector('.close-info');

    if ((localStorage.getItem('info-visibility') || 'visible') === 'visible') {
      this.show();
    } else {
      this.hide();
    }
  }

  hide() {
    if (this.openInfo) {
      this.openInfo.classList.add('d-none-important');
    }

    if (this.closeInfo) {
      this.closeInfo.classList.remove('d-none-important');
    }

    localStorage.setItem('info-visibility', 'hidden');
  }

  show() {
    if (this.openInfo) {
      this.openInfo.classList.remove('d-none-important');
    }

    if (this.closeInfo) {
      this.closeInfo.classList.add('d-none-important');
    }

    localStorage.setItem('info-visibility', 'visible');
  }
}
